import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { DeepLinkState } from '@core/deep-link/store/states/deep-link.state';
import { SetDeepLink } from '@core/deep-link/store/actions/deep-link.actions';
import { ResetStateFacade } from '@core/store/facades/reset-state.facade';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';

export const restrictedDeepLinkRoutes: ReadonlySet<string> = new Set<string>([ApplicationPath.Logout]);

@Injectable({
  providedIn: 'root',
})
export class DeepLinkFacade {
  private readonly store = inject(Store);
  private readonly resetStateFacade = inject(ResetStateFacade);

  readonly deepLink = this.store.selectSignal(DeepLinkState.deepLink);

  setDeepLink(deepLink: string): void {
    if (this.isRestrictedDeepLink(deepLink)) {
      return;
    }

    this.store.dispatch(new SetDeepLink(deepLink));
  }

  clearState(): void {
    this.resetStateFacade.clearState(DeepLinkState);
  }

  private isRestrictedDeepLink(deepLink: string): boolean {
    const route = deepLink.replace(/^\//, '').split(/[?#/]/)[0];
    return restrictedDeepLinkRoutes.has(route);
  }
}
